export default __webpack_public_path__ + "static/media/39.71f5ff3b.jpg";